import ItemTax from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperTax:null,
  errorInternal:false
};

function TaxReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ItemTax.RESET_LIST:
      return INITIAL_STATE;
    case ItemTax.NEW_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case ItemTax.UPDATE_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, single:null,isNewRecord:false};
    case ItemTax.VIEW_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, single:action.payload,isNewRecord:false,showModal:true};
    case ItemTax.RESET_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case ItemTax.DELETE_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case ItemTax.ON_SUBMIT:
      return { ...state,errorInternal:false,  onSubmit:true};
    case ItemTax.SHOW_DATA:
      return { ...state,errorInternal:false, onSubmit:false,  isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case ItemTax.SUCCESS_DATA:
      return { ...state,errorInternal:false, onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case ItemTax.PROCESS_DATA:
      return { ...state, isProcessing: true,onSubmit:false, isError: false,isSuccess:false};
    case ItemTax.ERROR_DATA:
      return { ...state, onSubmit:false, errorInternal:false,  isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case ItemTax.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
      case ItemTax.GET_HELPER_TAX:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,helperTax:action.payload};
    default:
      return state;
    }
}

export default TaxReducer;
